<template>
  <v-ons-page>

    <v-ons-toolbar modifier="noshadow">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Prix OS suivis</div>
    </v-ons-toolbar>

    <div class="content">

      <section class="content--perfecheance">

        <p>
          Quels prix OS souhaitez-vous suivre avec cette alerte&nbsp;?
        </p>

        <template v-for="negoceItem in prix">

          <v-ons-list-title v-if="prix.length > 1" modifier="perfdetail" :key="negoceItem.id">
            {{ negoceItem.label }}
          </v-ons-list-title>

          <v-ons-list modifier="noborder perflist" :key="negoceItem.id">

            <v-ons-list-item v-for="prixItem in negoceItem.list" :key="negoceItem.id + '-' + prixItem.id"
                             modifier="nodivider perfradio">
              <div class="left">
                <v-ons-checkbox modifier="material" :value="prixItem.id" v-model="select[negoceItem.id]"
                                :input-id="'checkbox-' + negoceItem.id + '-' + prixItem.id">
                </v-ons-checkbox>
              </div>
              <label class="center" :for="'checkbox-' + negoceItem.id + '-' + prixItem.id">
                {{ prixItem.label.replace(/([^•]) ([^•])/g, '$1&nbsp;$2') }}
                {{ prixItem.suffix }}
              </label>
            </v-ons-list-item>

          </v-ons-list>

        </template>

      </section>

    </div>

    <v-ons-bottom-toolbar modifier="cta transparent">
      <v-ons-button modifier="large--cta perflarge" @click="next">Valider</v-ons-button>
    </v-ons-bottom-toolbar>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      select: {},
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    prix() {
      return this.getPrixNegoce(this.getNegoceAcces(this.data.negoce.list), this.refCulture, this.refDestination);
    }
  },
  methods: {
    next() {
      var strategie = {
        negoce: {}
      };
      for (let i = 0; i < this.prix.length; i++) {
        var negoceItem = this.prix[i];
        strategie.negoce[negoceItem.id] = this.getSelectPrix(negoceItem, this.select);
      }

      this.mergeJson(store.state.user.ventes[this.refCulture][this.refDestination], strategie);
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/alerte'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            data: strategie
          }
        }
      });

      this.pageStack.pop();
    },
    getSelectPrix(negoceItem, select){
      var negoceArray = negoceItem.list.map(value => {
        var prixId = value.id.toString();
        if(select[negoceItem.id] && select[negoceItem.id].includes(prixId)){
          return null;
        } else {
          return prixId;
        }
      });
      return negoceArray.filter(value => {return value !== null});
    }
  },
  created() {
    var strategie = this.user.ventes[this.refCulture][this.refDestination];
    for (let i = 0; i < this.prix.length; i++) {
      var negoceItem = this.prix[i];
      this.$set(this.select, negoceItem.id, this.getSelectPrix(negoceItem, strategie.negoce));
    }
  }
};
</script>

<style scoped>
.content--perfecheance {
  text-align: center;
}
.content--perfecheance > p {
  background: #fff;
  margin: 0;
  padding: 25px 50px;
  font-weight: 500;
  line-height: 25px;
}
.content--perfecheance .list--perflist {
  background: #fff;
  padding: 25px 0 25px 25px;
}
.content--perfecheance .list-title--perfdetail + .list--perflist {
  padding-left: 0;
}
</style>